import axios from "axios";

// export const base_url = "https://bfdcf1a5bac7.ngrok-free.app/";
// export const base_url = "https://driverapp.lynk.ie/api/";
// export const base_url = "http://192.168.1.87:9999/";

//Live URL
export const base_url = "https://driverapp.lynk.ie/api/";

//Staging URL
// export const base_url = "https://driverapp.lynk.ie/api/v1/";
// export const base_url = 'http://192.168.29.231:8888/apiv/';

export const fetchDataFromAPI = (url, method, data, token) =>
  new Promise((resolve, reject) => {
    // console.debug(
    //   "----------------APICAll(fetchDataFromAPI)------------------------"
    // );
    // console.log("Url", Base_URL + url);
    // console.log("method", method);
    // console.log("Body", body);
    // console.log("Token", token);

    var headers;

    if (token != null) {
      headers = {
        Accept: "application/json",
        "ngrok-skip-browser-warning": "true",
        Authorization: `Bearer ${token}`,
      };
    } else {
      headers = {
        "ngrok-skip-browser-warning": "true",
        Accept: "application/json",
      };
    }
    if (data) {
      axios({
        method: method,
        baseURL: base_url + url,
        headers: headers,
        data: data,
      })
        .then((response) => {
          // When api send success response set in resolve method
          //   console.log("check main response",response)
          return resolve(response.data);
        })
        .catch((error) => {
          // When api send success response set in resolve method
          return reject(error);
        });
    } else {
      axios({
        method: method,
        baseURL: base_url + url,
        headers: headers,
      })
        .then((response) => {
          // When api send success response set in resolve method
          //   console.log("check main response",response)
          return resolve(response.data);
        })
        .catch((error) => {
          // When api send success response set in resolve method
          return reject(error);
        });
    }
  });
